export const joinValuesToString = (value: any) => {
  if (!value || !value.length) {
    return null;
  }
  if (typeof value === 'string') {
    return value;
  } else {
    return `[${value.join(';')}]`;
  }
};
